module.exports = __webpack_public_path__ + "img/bio_extratus.3c1092d7.svg";